import { Component, EventEmitter, HostListener, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ConductorDTO } from '../../../dtos/conductor.dto';
import { ConductorService } from '../../services/conductor.service';
import moment from "moment";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../../app.message';
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../services/event.service';
import { UserService } from '../../services/user.service';
import { JornadaDTO } from "../../../dtos/jornada.dto";
import { PdfDTO } from "../../../dtos/pdf.dto";
import { ConfiguracionEstadoConductorDTO } from "../../../dtos/configuracionEstadoConductor.dto";

@Component({
  selector: 'app-modal-cambiar-estado-cb',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-cambiar-estado-cb.component.html',
  styleUrl: './modal-cambiar-estado-cb.component.scss'
})
export class ModalCambiarEstadoCbComponent implements OnInit {

  private conductor: ConductorDTO;
  public estadoConductor = 'SELECCIONE';
  contrato: string;
  estadoFechaInicio: string;

  public procesandoPdf: boolean = false;
  public enviando: boolean = false;

  //CON-1056: reglas de duracion que entrega el back. Mientras no lleguen, el modal se comporta
  //como antes: sin celda de tiempo y sin boton de vale.
  public configuraciones: Array<ConfiguracionEstadoConductorDTO> = [];
  //Duracion del estado en HH:MM, que es el formato que pidio el cliente. Se maneja en dos campos
  //porque el input nativo de hora no deja leer lo tecleado mientras este incompleto (06:--), y sin
  //eso no se puede completar el lado que el usuario dejo vacio.
  public duracionHoras: string = '';
  public duracionMinutos: string = '';

  constructor(
    private modalRef: BsModalRef,
    private conductorService: ConductorService,
    private apiService: ApiService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService,
  ) {

    this.eventService.subscribe('CONDUCTOR_ACTUALIZADO_MQTT_EVENT', (conductor: ConductorDTO) => {
      if (conductor.uuid == this.conductor.uuid) {
        this.conductor = conductor;
      }
    })
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  ngOnInit(): void {
    this.conductor = this.conductorService.getConductorSeleccionado();
    console.log(this.conductor)
    this.cargarConfiguracionEstados();
  }

  //CON-1056 -----------------------------------------------------------------------------------

  cargarConfiguracionEstados() {
    this.apiService.getConfiguracionEstadosConductor().subscribe({
      next: (resp) => this.configuraciones = resp.data || [],
      //si la configuracion no llega se sigue pudiendo cambiar de estado: solo no se ofrece
      //la duracion ni el vale, en vez de dejar el modal inutilizable
      error: (err) => console.log('error configuracion estados conductor', err)
    });
  }

  getConfiguracion(codigoEstado: string): ConfiguracionEstadoConductorDTO {
    if (!codigoEstado) return null;
    return this.configuraciones.find(c => c.codigoEstado === codigoEstado) || null;
  }

  /** Configuracion del estado elegido en el select, o null si ese estado no maneja duracion. */
  get configSeleccionada(): ConfiguracionEstadoConductorDTO {
    return this.getConfiguracion(this.estadoConductor);
  }

  /** Configuracion del estado en que esta el conductor ahora, que es el vale que se reimprime. */
  get configEstadoActual(): ConfiguracionEstadoConductorDTO {
    return this.conductor ? this.getConfiguracion(this.conductor.estado) : null;
  }

  /** El vale se puede volver a imprimir mientras el conductor siga en un estado que lo tiene. */
  get puedeReimprimirVale(): boolean {
    return this.configEstadoActual != null;
  }

  get duracionEditable(): boolean {
    const config = this.configSeleccionada;
    return config != null && config.libreParaUsuario;
  }

  /** Al elegir otro estado se propone su tiempo: el fijo si lo tiene, si no el sugerido. */
  onEstadoSeleccionado() {
    const config = this.configSeleccionada;
    if (!config) {
      this.setDuracion(null);
      return;
    }
    //CAPACITACION no trae sugerencia: la celda queda vacia y se puede dejar asi
    this.setDuracion(config.minutosFijos != null ? config.minutosFijos : config.minutosSugeridos);
  }

  private setDuracion(minutos: number) {
    if (minutos == null) {
      this.duracionHoras = '';
      this.duracionMinutos = '';
      return;
    }
    this.duracionHoras = this.pad(Math.floor(minutos / 60));
    this.duracionMinutos = this.pad(minutos % 60);
  }

  /**
   * Al salir del campo se completa el lado que quedo vacio: si escribio 6 en la hora la duracion
   * es 06:00, y si escribio 45 en los minutos es 00:45. Se hace al salir y no mientras teclea para
   * no pisarle el segundo digito.
   */
  completarDuracion() {
    const hayHoras = this.duracionHoras !== '' && this.duracionHoras != null;
    const hayMinutos = this.duracionMinutos !== '' && this.duracionMinutos != null;

    if (!hayHoras && !hayMinutos) return;

    this.duracionHoras = hayHoras ? this.pad(parseInt(this.duracionHoras, 10)) : '00';
    this.duracionMinutos = hayMinutos ? this.pad(parseInt(this.duracionMinutos, 10)) : '00';
  }

  /** Duracion total en minutos, o null si el usuario dejo los dos campos vacios. */
  getMinutosDuracion(): number {
    const horas = this.duracionHoras !== '' && this.duracionHoras != null ? parseInt(this.duracionHoras, 10) : null;
    const minutos = this.duracionMinutos !== '' && this.duracionMinutos != null ? parseInt(this.duracionMinutos, 10) : null;

    if (horas == null && minutos == null) return null;
    if (isNaN(horas) || isNaN(minutos)) return null;

    return (horas || 0) * 60 + (minutos || 0);
  }

  hhmmDesdeMinutos(minutos: number): string {
    return `${this.pad(Math.floor(minutos / 60))}:${this.pad(minutos % 60)}`;
  }

  get colacionPermitida(): boolean {

    if (!this.conductor) {
      return false;
    }

    if (!this.conductor.jornadaEnCurso) {
      return false;
    }

    return this.conductor.jornadaEnCurso.colacionPermitida;
  }

  cambiarEstado() {
    if (this.estadoConductor === 'SELECCIONE') {
      this.toastr.warning('Debe seleccionar un estado', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    const config = this.configSeleccionada;
    //CON-1056: solo se mandan minutos si el usuario los puede cambiar. En los estados de tiempo
    //fijo el back ignora lo que llegue, y en los que no manejan duracion no corresponde mandarlos.
    let minutos: number = null;
    if (config && config.libreParaUsuario) {
      this.completarDuracion();
      minutos = this.getMinutosDuracion();
      if (minutos != null && (minutos < 1 || minutos > config.minutosMaximos)) {
        this.toastr.warning(`La duración debe estar entre 00:01 y ${this.hhmmDesdeMinutos(config.minutosMaximos)}`, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
        return;
      }
    }

    this.enviando = true;
    this.apiService.putCambiarEstadoGestionConductores(this.conductor.uuid, this.estadoConductor, minutos).subscribe({
      next: (res) => this.actualizarEstadoSuccess(res, config != null),
      error: (err) => this.actualizarEstadoError(err)
    });
  }

  actualizarEstadoSuccess(resp: any, imprimir: boolean) {
    console.log({ resp })
    this.eventService.publish('CAMBIAR_ESTADO_CONDUCTORES_EVENT');
    if (imprimir) {
      //CON-1056: el vale lo dispara el front al entrar al estado; el back no imprime solo
      this.imprimirValeEstado();
    } else {
      this.enviando = false;
      this.close();
    }
  }

  actualizarEstadoError(error: HttpErrorResponse) {
    console.log('error lista viajes', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CAMBIAR_ESTADO_CONDUCTORES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  // imprimirVoucherColacion(uuidConductor) {
  //   if (!uuidConductor)
  //     return;

  //   this.loadingImprimir = true;
  //   this.apiService.getColacionPDF(uuidConductor).subscribe(
  //     (resp) => this.getColacionPDFSuccess(resp),
  //     (error) => this.getColacionPDFError(error)
  //   );
  // }

  // getColacionPDFSuccess(pdfDTO: PdfDTO,) {
  //   console.log('exito pdf');
  //   this.loadingImprimir = false;
  //   if (pdfDTO.base64Content)
  //     pdfDTO.generatePdfFromBase64();
  //   else
  //     this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito');
  //   // this.alertService.presentAlertaInfo(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`);
  // }

  // getColacionPDFError(error: HttpErrorResponse) {
  //   console.log('error kpis', error);
  //   this.loadingImprimir = false;
  //   const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
  //   //alert(msg);
  //   // this.toastr.error(msg, 'Error');
  //   this.alertService.presentAlertaError(msg, error);
  // }

  close() {
    this.modalRef.hide();
  }

  tienePermisoCambiarEstado(): boolean {
    return this.userService.tienePermiso('CONDUCTOR_CAMBIAR_ESTADO');
  }

  get getConductor(): ConductorDTO {
    return this.conductor;
  }

  get getTiempoEnEstadoHHmm(): string {
    // const ahora = moment();
    // const inicio = moment.utc(this.conductor.jornadaEnCurso.fechaHoraInicio).local();

    // if (!inicio.isValid()) {
    //   return "--";
    // }

    // const diff = moment.duration(ahora.diff(inicio));
    // const horas = Math.floor(diff.asHours());
    // const minutos = diff.minutes();

    // return `${this.pad(Math.abs(horas))}:${this.pad(Math.abs(minutos))}`;
    if (!this.estadoFechaInicio) return '';

    const fechaAhora = moment.utc();
    const fechaInicio = moment.utc(this.estadoFechaInicio);
    const duracion = moment.duration(fechaAhora.diff(fechaInicio));

    const horas = Math.floor(duracion.asHours());
    const minutos = duracion.minutes();

    return `${this.pad(horas)}:${this.pad(minutos)}`;
  }

  pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  /**
   * CON-1056: imprime el vale del estado en que quedo el conductor. El mismo endpoint sirve para
   * la impresion al entrar al estado y para la reimpresion desde el boton, y cubre los cinco
   * estados -incluida la colacion-, asi que no se llama ademas al endpoint viejo de colacion.
   */
  imprimirValeEstado(cerrarAlTerminar: boolean = true) {
    this.procesandoPdf = true;
    this.apiService.getEstadoConductorPDF(this.conductor.uuid).subscribe(
      (resp) => this.getColacionPDFSuccess(resp, cerrarAlTerminar),
      (error) => this.getColacionPDFError(error)
    );
  }

  /** Reimpresion desde el boton: el conductor ya esta en el estado, no se cambia nada. */
  reimprimirValeEstado() {
    this.imprimirValeEstado(false);
  }

  getColacionPDFSuccess(pdfDTO: PdfDTO, cerrarAlTerminar: boolean = true) {
    console.log('exito pdf');
    this.procesandoPdf = false;
    this.enviando = false;
    if (pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });

    // this.alertService.presentAlertaInfo(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`);

    if (cerrarAlTerminar)
      this.close();
  }

  getColacionPDFError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    this.procesandoPdf = false;
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }
}
